class WaveSectionHowWork implements ng.IComponentController {
    stepsNames: string[];
    reverse: boolean;
    steps: anm.VideoStep[] = [
        {
            name: 'choose-video',
            title: 'subtitle1',
            content: 'text1',
            anonymousBtnName: 'link1',
            btnName: 'link1',
            videoUrl: 'step1'
        },
        {
            name: 'add-text',
            title: 'subtitle2',
            content: 'text2',
            anonymousBtnName: 'link2',
            btnName: 'link2',
            videoUrl: 'step2'
        },
        {
            name: 'cta',
            title: 'subtitle3',
            content: 'text3',
            anonymousBtnName: 'link3',
            btnName: 'link3',
            videoUrl: 'step3'
        },
        {
            name: 'choose-music',
            title: 'subtitle4',
            content: 'text4',
            anonymousBtnName: 'link4',
            btnName: 'link4',
            videoUrl: 'step4'
        },
        {
            name: 'import-files',
            title: 'import-files.title',
            content: 'import-files.content',
            anonymousBtnName: 'btnName',
            btnName: 'btnName',
            videoUrl: 'lu_step1'
        },
        {
            name: 'choose-video-2',
            title: 'choose-video-2.title',
            content: 'choose-video-2.content',
            anonymousBtnName: 'btnName',
            btnName: 'btnName',
            videoUrl: 'lu_step2'
        },
        {
            name: 'customize-video',
            title: 'customize-video.title',
            content: 'customize-video.content',
            anonymousBtnName: 'btnName',
            btnName: 'btnName',
            videoUrl: 'lu_step3'
        },
        {
            name: 'preview-results',
            title: 'preview-results.title',
            content: 'preview-results.content',
            anonymousBtnName: 'btnName',
            btnName: 'btnName',
            videoUrl: 'lu_step4'
        },
    ].map(step => this.mapSteps(step));

    private mapSteps(step: anm.VideoStep): anm.VideoStep {
        const getTranslate = (val: string) => `wv.landing.content.block2.${val}`;
        const getVideoUrl  = (val: string) => `https://videos.animatron.com/landing/wave/${val}.mp4`;

        return {
            ...step,
            title: getTranslate(step.title),
            content: getTranslate(step.content),
            anonymousBtnName: getTranslate(step.anonymousBtnName),
            btnName: getTranslate(step.btnName),
            videoUrl: getVideoUrl(step.videoUrl)
        };
    }

    $onChanges() {
        if (!this.stepsNames) return;
        this.steps = this.stepsNames.map(stepName =>
            this.steps.filter(step => step.name === stepName)[0]
        );
    }

}

angular.module('animatronApp.wave.sectionHowWork', []).component('waveSectionHowWork', {
    bindings: {
        stepsNames: '<',
        reverse: '<'
    },
    transclude: true,
    controller: WaveSectionHowWork,
    templateUrl: require('wave/wave-section-how-work.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/wave/waveSectionHowWork.ts